import { useCallback, useEffect, useMemo, useState } from 'react';
import countryList from 'react-select-country-list';
// import countryCodes from 'country-codes-list';
import { Link } from 'react-router-dom';
import Tippy from '@tippy.js/react';

// components
import Dropdown from '../../common/dropdown/Dropdown';
import CreatePassword from './CreatePassword';

// hooks
import useDebounce from '../../hooks/useDebounce';

// Images
import { arrowRight, hr } from '../../assets/images/login';

//utils
import { baseUrl_, hasTypo } from '../../utils/constants';
import { isEmailValid } from '../../utils/validateEmail';

// Types
import { OptionType } from '../../types';

// styles sheet
import styles from './loginForm.module.css';
import 'tippy.js/dist/tippy.css';
import { toast } from 'react-toastify';
import { countryCodes } from '../../utils/countryCodes';
import { encryptData } from '../../utils/encryptJson';
import axios from 'axios';
import { registerNetcoreActivity } from '../../utils/registerActivity';
import ReactGA from 'react-ga4';
import customToast, { ToastType } from '../../components_/Toast';
import ConfirmEmailModal from './ConfirmEmailModal';

const SignupForm = () => {
  const [onCreatePassword, setOnCreatePassword] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  // const [username, setUsername] = useState('');

  const [dao, setDao] = useState('');
  const [other, setOther] = useState('');
  const [disabled, setDisabled] = useState(true);
  const countries = useMemo(() => countryList().getData(), []);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<OptionType>({
    value: 'Country of residence',
    label: 'Country of residence',
  });
  const [selectedReferralOption, setSelectedReferralOption] = useState<OptionType>({
    value: 'How did you hear about us?',
    label: 'How did you hear about us?',
  });

  const [checked, setChecked] = useState(false);

  const handleCheckboxChange = () => {
    setChecked(!checked);
  };
  const [showTippy, setShowTippy] = useState(false);
  const [existingEmail, setExistingEmail] = useState<boolean>(false);
  const debouncedSearch = useDebounce(email, 900);

  const checkEmailExist = useCallback(() => {
    setExistingEmail(false);
    async function fetchData() {
      const postData = {
        email: email,
      };
      try {
        axios
          .post(`${baseUrl_}/auth/checkemail`, {
            headers: {
              'Content-Type': 'application/json',
              sessId: localStorage.getItem('sessId') ?? '',
            },
            body: encryptData(postData),
          })
          .then((data) => {
            if (data.status === 409) {
              setExistingEmail(true);
              customToast(
                'email already exist. please login instead',
                ToastType.error,
                '',
                6000,
                'error1',
              );
            }
          });
      } catch (error) {
        setExistingEmail(false);
      }
    }
    if (debouncedSearch) fetchData();
  }, [debouncedSearch, email]);

  useEffect(() => {
    checkEmailExist();
  }, [checkEmailExist]);

  const referralOption = [
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Sterling staff/RSO', label: 'Sterling staff/RSO' },
    { value: 'Others', label: 'Others' },
  ];

  const isRefValid = () => {
    if (selectedReferralOption.label === 'How did you hear about us?') {
      return false;
    }
    if (selectedReferralOption.label === 'Others' && !other) {
      return false;
    }
    return true;
  };

  //   SIGNUP VALIDATION
  const validateInputsResult = useMemo(() => {
    const isPhoneValid = !!phoneNumber;
    const isfirstNameValid = firstName.length !== 0;
    const islastNameValid = lastName.length !== 0;
    const isCountryValid = selectedCountry.value !== 'Country of residence';
    const isReferralValid = isRefValid();
    const isDaoValid =
      selectedReferralOption.label !== 'Sterling staff/RSO' ? true : dao.length !== 0;
    const notExistingEmail = existingEmail === false;

    return (
      isCountryValid &&
      // isUsernameValid &&
      isEmailValid(email) &&
      isDaoValid &&
      isfirstNameValid &&
      islastNameValid &&
      isPhoneValid &&
      isReferralValid &&
      checked &&
      notExistingEmail
    );
  }, [
    phoneNumber,
    selectedCountry,
    selectedReferralOption,
    dao,
    checked,
    firstName.length,
    lastName.length,
    existingEmail,
    email,
    other,
  ]);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);

  const codes: any = countryCodes;
  const countryCode = codes[selectedCountry.value] ?? `+234`;
  const onProceed = () => {
    registerNetcoreActivity(
      {
        emailAddress: email && email,
        firstName: firstName && firstName,
        lastName: lastName && lastName,
        mobileNumber: phoneNumber && phoneNumber,
      },
      'TBH_SIGN_UP_PROCEED_TO_INPUT_PASSWORD',
    );

    ReactGA.event({
      category: 'Button',
      action: 'TBH_SIGN_UP_PROCEED_TO_INPUT_PASSWORD',
      label: 'TBH_SIGN_UP_PROCEED_TO_INPUT_PASSWORD',
      // value: 1
    });
    if (!disabled) {
      setOnCreatePassword(true);
    }
  };
  return !onCreatePassword ? (
    <>
      <div className={styles.signupformContainer}>
        <Link to={'/'}>
          <div className={styles.signUpText}>
            Log in
            <img src={arrowRight} className='pl-2' alt='alt.png' />
          </div>
        </Link>

        <div className='mb-1 text-[12px]'>
          <h3 className={styles.loginText}>{`Let's get you started`}</h3>
          <p>Create your free account</p>
          <img src={hr} alt='alt.png' />
        </div>

        <div>
          <input
            placeholder='First Name'
            className={styles.signupInput}
            type='text'
            value={firstName}
            onChange={(e) => {
              // const re = /^[0-9\b]+$/;
              const re = /^[A-Za-z-]+$/;
              if (e.target.value === '' || re.test(e.target.value)) {
                setFirstName(e.target.value);
              }
            }}
          />
        </div>

        <div>
          <input
            placeholder='Last Name'
            className={styles.signupInput}
            type='text'
            value={lastName}
            onChange={(e) => {
              const re = /^[A-Za-z-]+$/;
              if (e.target.value === '' || re.test(e.target.value)) {
                setLastName(e.target.value);
              }
            }}
          />
        </div>

        <div style={{ position: 'relative' }}>
          <input
            placeholder='Email Address'
            className={styles.signupInput}
            type='email'
            value={email}
            onChange={(e) => setEmail(e.target.value.toLowerCase())}
          />
          <i
            style={{
              position: 'absolute',
              transform: 'translateY(-50%)',
              top: '52%',
              marginLeft: '-20px',
              paddingTop: '10px',
              color: 'red',
            }}
            className={
              existingEmail
                ? 'fa fa-exclamation-circle' //some condition 'fa fa-times' :
                : ''
            }
            aria-hidden='true'
          ></i>
        </div>

        <div className='mt-[1.2em]'>
          <Dropdown
            options={countries}
            placeholder={selectedCountry.label}
            setSelectedOption={setSelectedCountry}
            width='[100%]'
            borderColor='border-[#768396]'
            placeholderFont='text-[13px]'
          />
        </div>

        <div style={{ position: 'relative' }} className='flex flex-row w-[100%] items-end'>
          <div
            style={{
              border: '1px solid #798396',
              borderRadius: '2px',
              height: '41px',
              display: 'flex',
              alignItems: 'center',
              width: '25%',
              justifyContent: 'center',
              color: '#798396',
            }}
          >
            {codes[selectedCountry.value] ?? `+234`}
          </div>
          <Tippy
            visible={showTippy}
            className='bg-[wheat] text-xs text-[black] w-[280px]'
            arrow={false}
            content={`For Nigerian Numbers, enter number without 0 e.g 816*******`}
          >
            <input
              placeholder='Phone number'
              className={[styles.signupInput, 'flex-1'].join(' ')}
              value={phoneNumber}
              onBlur={() => setShowTippy(false)}
              onChange={(e) => {
                const re = /^[0-9\b]+$/;
                if (e.target.value === '' || re.test(e.target.value)) {
                  setPhoneNumber(e.target.value);
                }
                setShowTippy(true);
              }}
            />
          </Tippy>
        </div>

        <div className='mt-[1.2em]'>
          <Dropdown
            options={referralOption}
            placeholder={selectedReferralOption.label}
            setSelectedOption={setSelectedReferralOption}
            width='w-[100%]'
            borderColor='border-[#768396]'
            placeholderFont='text-[13px]'
          />
        </div>

        {selectedReferralOption.label === 'Sterling staff/RSO' && (
          <div className=''>
            <input
              placeholder='Enter the name or the referral code for the staff*'
              className={styles.signupInput}
              type='text'
              value={dao}
              onChange={(e) => {
                setDao(e.target.value);
              }}
            />
          </div>
        )}

        {selectedReferralOption.label === 'Others' && (
          <div className=''>
            <input
              placeholder='Please tell us where*'
              className={styles.signupInput}
              type='text'
              value={other}
              onChange={(e) => {
                setOther(e.target.value);
              }}
            />
          </div>
        )}

        <div className='mt-[1.2em] text-[13px] flex items-center'>
          <input
            type={'checkbox'}
            checked={checked}
            onChange={handleCheckboxChange}
            className='mr-[.5em]'
          />
          <p className='font-Poppins font-normal text-sm'>
            I agree to the{' '}
            <Link
              to='/terms-of-service'
              // target='_blank'
              style={{ color: '#028789', cursor: 'pointer' }}
            >
              Terms of Service
            </Link>
          </p>
        </div>

        <div className='flex justify-center mt-6'>
          <button
            onClick={() => {
              !disabled && setOpenConfirmModal(true);
            }}
            className={[
              disabled ? 'bg-[grey] !cursor-not-allowed' : 'bg-[#229698]',
              'w-[100%] text-center text-[#FFFFFF] p-2 mb-0 rounded-[6px]',
            ].join(' ')}
          >
            Proceed
          </button>
        </div>
      </div>

      <ConfirmEmailModal
        handleProceed={() => onProceed()}
        email={email}
        isOpen={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
        hasTypo={hasTypo(email)}
        setEmail={setEmail}
      />
    </>
  ) : (
    <CreatePassword
      registrationDetails={{
        firstName,
        lastName,
        email,
        daoCode: dao,
        // userName: username,
        country: selectedCountry.label,
        phoneNumber: countryCode + phoneNumber,
        heardAboutUs:
          selectedReferralOption.label === 'Others' ? other : selectedReferralOption.label,
      }}
      onCreatePassword={setOnCreatePassword}
    />
  );
};

export default SignupForm;
